"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles = __importStar(require("./Initials.module.css"));
var mobx_react_1 = require("mobx-react");
var moment = require("moment");
var react_1 = require("react");
var Initials = (function (_super) {
    __extends(Initials, _super);
    function Initials(props) {
        var _this = _super.call(this, props) || this;
        _this.json_data = props.model.json_data;
        props.model.dispatcher.addListener(function () {
            _this.json_data = props.model.json_data;
            _this.forceUpdate();
        });
        return _this;
    }
    Initials.prototype.onClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, id, onChange, model, type, nextInputId, event_1, nextInputRef;
            return __generator(this, function (_b) {
                _a = this.props, id = _a.id, onChange = _a.onChange, model = _a.model, type = _a.type, nextInputId = _a.nextInputId;
                if (!this.json_data[type]) {
                    event_1 = new Event("show_signature_popup");
                    event_1["options"] = { id: id, type: type, nextInputId: nextInputId };
                    window.dispatchEvent(event_1);
                }
                else if (nextInputId) {
                    nextInputRef = document.getElementById(nextInputId);
                    nextInputRef.focus();
                }
                this.json_data[id] = "1";
                this.json_data[id + "_date"] = moment.utc().format();
                model.dispatcher.dispatch();
                return [2];
            });
        });
    };
    Initials.prototype.render = function () {
        var _a = this.props, id = _a.id, onChange = _a.onChange, model = _a.model, _b = _a.errors, errors = _b === void 0 ? {} : _b, className = _a.className, classNameWrap = _a.classNameWrap, underline = _a.underline, title = _a.title;
        var error = errors[id];
        var src = model.json_data[this.props.type] || "#";
        var isSigned = Boolean(model.json_data[this.props.id]);
        var extraClass = "";
        if (window.isPdf) {
            extraClass = "hide";
        }
        var html = React.createElement("img", { src: src, width: "150", height: "75" });
        if (!isSigned && !className.includes("disabled-user-field")) {
            html = (React.createElement("button", { id: id + "_btn", onClick: this.onClick.bind(this), className: styles.button + " " + extraClass }, "Click"));
        }
        var date = "";
        if (isSigned) {
            date = moment(this.json_data[id + "_date"]).format("MM/DD/YYYY");
        }
        return (React.createElement("div", { className: classNameWrap },
            React.createElement("div", { className: "" + styles.root },
                React.createElement("div", { className: underline ? "" + styles.underline : "" },
                    React.createElement("div", { id: id, className: styles.box + " " + className, tabIndex: 0 }, html)),
                error && React.createElement("p", { className: styles.error },
                    error,
                    " "),
                underline && React.createElement("em", null,
                    " Intial ",
                    title,
                    " "))));
    };
    Initials.defaultProps = {
        type: "initial"
    };
    Initials = __decorate([
        mobx_react_1.observer
    ], Initials);
    return Initials;
}(react_1.Component));
exports.Initials = Initials;
//# sourceMappingURL=data:application/json;base64,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